<template>
    <div class="newspaper-detail">
        <bookNav :showSearch="true" @bkSearchShow="bkSearchShow" @bkSearchHide="bkSearchHide"></bookNav>
        <div :class="bkSearchTabShow ? 'newspaper-box cur' : 'newspaper-box'">
            <div class="left-info">
                <!-- <img src="/xinwenbaobg.jpg" alt=""> -->
                <img  v-if="newspaperData && newspaperData.cover"
                    :src="'https://dhc.library.sh.cn/bkimg/bz/'+newspaperData.cover" 
                    onerror="onerror=null;src='/xinwenbaobg.jpg';console.clear()" alt=""
                >
                <div class="btns">
                    <a href="javascript:;" @click="newspaperSearch">报内搜索</a>
                    <a href="javascript:;" @click="onExport">信息导出</a>
                </div>
                <div class="des">
                    <p v-if="newspaperData && newspaperData.titleChs"><span>报名</span>{{newspaperData.titleChs}}</p>
                    <p v-if="newspaperData && newspaperData.chiefEditorUri">
                        <span>责任者</span>
                        <i v-html="arrToString(newspaperData.chiefEditorUri, 'person.nameChs.@id', '、')"></i>
                    </p>
                    <p v-if="newspaperData && newspaperData.created"><span>创报时间</span>{{newspaperData.created}}</p>
                    <p v-if="newspaperData && newspaperData.publisher"><span>出版者</span>{{listUniqToString(newspaperData.publisher, 'name', '、')}}</p>
                    <p v-if="newspaperData && newspaperData.provisionActivity"><span>出版地</span>{{listUniqToString(newspaperData.provisionActivity, "place.chsPlc", '、')}}</p>
                    <p v-if="newspaperData && listUniqToString(newspaperData.language, 'languagelabel', '、')"><span>语种</span>{{listUniqToString(newspaperData.language, 'languagelabel', '、')}}</p>
                </div>
            </div>
            <div class="right-content">
                <div class="newspaper-des">
                    <i class="icon" @click="onIcon"></i>
                    <h5>报纸简介</h5>
                    <div class="content" v-if="newspaperData && newspaperData.description">
                        <!-- <p>文学刊物。该刊由鲁迅等人发起，北京大学新潮社编辑的刊物，北新书局发行，周刊，共260期，1924年11月17日发行第1期。1924年11月17日至1927年10月22日的第1期至第156期由周作人编辑。1924年10月出至154期杂志被奉系军阀查封，从北京迁往上海，后由上海语丝社继续编辑出版。自1924年12月17日4卷第1期始由鲁迅编辑，到1929年1月7日第52期截止，后第5卷1—26期由柔石编辑，27-52期由李小峰编辑，到1930年3月10日第52期出版后刊物停刊。</p>
                        <p>主要撰稿人有周作人、鲁迅、林语堂、钱玄同、孙伏园、俞平伯、刘半农、梁遇春、顾颉刚、章川岛、江绍原等。</p>
                        <p>刊物提倡自由思想，独立判断及和美的生活，介绍研究文学创作及艺术思想，发表学术论著，主要刊载散文杂文，亦刊登小说诗歌创作和学术论文，如发刊辞所言：“周刊上的文字大抵以简短的感想和批评为主，但也兼采文艺创作以及关于文学美术和一般思想的介绍与研究，在得到学者的援助时也要发表学术上的重要论文。”刊物刊载了鲁迅与周作人的大量小品文与杂文，此外鲁迅的《野草》也刊登在杂志上。杂志亦刊载顾颉刚的疑古史学的论文。尽管语丝社同仁的思想和艺术主张不尽一致，但它们的文章有共同的风格：排旧促新，放纵而谈，古今并论，庄谐杂出，简洁明快，不拘一格，因此形成了“语丝体”。</p> -->
                        <span v-html="newspaperData.description"></span>
                    </div>
                </div>

                <div class="top-filter">
                    <div class="filter">
                        <div class="lb">年份</div>
                        <div class="years">
                            <template v-for="y in yearLength">
                                <span :key="y" :class="choseYearD===y?'cur':''" @click="changeYearD(y)">
                                    <i :class="choseYear===(y*10+baseYear)?'cur':''">{{y*10+baseYear}}</i>
                                </span>
                                <div :key="'y'+y" :class="choseYearD===y?'an cur':'an'">
                                    <span v-for="y2 in 9" :key="y2+y+Math.random()" 
                                        :class="choseYear===(y*10+baseYear+y2)?'y2 cur':'y2'" 
                                        @click="changeYear(y*10+baseYear+y2)" 
                                        v-show="baseYearList.includes(y*10+baseYear+y2+'')">
                                        <i>{{y*10+baseYear+y2}}</i>
                                    </span>
                                </div>
                            </template>
                            <!-- <span v-for="(yearItem, index) in yearsList" :key="'y'+index"
                                :class="choseYear===yearItem.year?'cur':''" 
                                @click="choseYearFunc(yearItem, index)">{{yearItem.year}}</span> -->
                        </div>
                    </div>
                    <div class="filter">
                        <div class="lb">月份</div>
                        <div class="wks">
                            <!-- <span v-for="m in 12" :key="m+Math.random()" :class="choseMonth===m?'cur':''" @click="changeMonth(m)">{{m}}月</span> -->
                            <span v-for="(m, index) in monthsList" :key="index+Math.random()" 
                                :class="choseMonth===m.month?'cur':''" 
                                @click="changeMonth(m, index)">{{m.month}}月</span>
                        </div>
                    </div>
                    <div class="filter">
                        <div class="lb">日期</div>
                        <div class="wks">
                            <!-- <span v-for="d in dateCount" :key="d+Math.random()" :class="choseDate===d?'cur':''" @click="changeDate(d)">{{d}}</span> -->
                            <!-- @click="changeDate(d)"  -->
                            <span v-for="(d, index) in daysList" :key="index+Math.random()" 
                                :class="choseDate===d?'cur':''" 
                                @click="changeDate(d, index)" @mouseenter="handleHover($event, d, index)"
                                @mouseleave="handleLeave"
                            >{{d}}</span>
                        </div>
                    </div>
                </div>
                <div class="pager">
                    <span class="cur" @click="prev">上一期</span>
                    <span class="cur" @click="prev"><a-icon type="left"></a-icon></span>
                    <span>{{choseYear}}年{{choseMonth}}月{{choseDate?choseDate+'日':choseDate}}</span>
                    <span class="cur" @click="next"><a-icon type="right"></a-icon></span>
                    <span class="cur" @click="next">下一期</span>
                </div>

                <div class="result-tab" v-if="newspaperTab">
                    <table class="tabs">
                        <thead>
                            <tr>
                                <th style="width:40%">题名</th>
                                <th style="width:20%" class="cur">责任者</th>
                                <th style="width:20%">页码</th>
                                <th style="width:20%"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in newspaperList" :key="'article'+index">
                                <td>
                                    <span v-if="item.hasOwnProperty('title') || item.hasOwnProperty('work')"
                                    >{{item.title || item.work.title}}</span>
                                </td>
                                <td>{{arrayToString(item.co, 'agent', ' ')}}</td>
                                <td>
                                    <span v-if="item.hasOwnProperty('layout')">{{'第'+item.layout.serialNo+'版'}}</span
                                    ><span v-if="item.hasOwnProperty('issue')">{{'第'+item.issue.serialNo+'页'}}</span>
                                </td>
                                <td class="icon-img">
                                    <a href="javascript:;" @click="fullBrowse(item)"
                                        v-if="item.titlePy.indexOf('ti xiao yin yuan')!=-1 && item.source.indexOf('《新闻报》')!=-1"><img src="./img/yulanc.png" title="整本浏览" alt=""></a>
                                    <a href="javascript:;" @click="dpBrowse(item)"
                                        v-if="item.titlePy.indexOf('ti xiao yin yuan')!=-1 && item.source.indexOf('《新闻报》')!=-1"><img src="./img/yulan2c.png" title="单篇预览" alt=""></a>
                                    <a href="javascript:;" @click="zjBrowse(item)" 
                                        v-if="item.hasOwnProperty('work')&&item.titlePy.indexOf('ti xiao yin yuan')!=-1 && item.source.indexOf('《新闻报》')!=-1">
                                        <img src="./img/zhuanjic.png" title="专辑浏览" alt="">
                                    </a>
                                    <!-- <a href="javascript:;" @click="starCollect(index)" v-if="Common.userInfo"> -->
                                        <a href="javascript:;" @click="handleFav(item['@id'], item.title||'', item.titlePy||'')" v-if="Common.userInfo">
                                        <img class="star" src="./img/star2.png" title="收藏" alt="" v-if="collectedDataSource.indexOf(item['@id'])>-1">
                                        <img class="star" src="./img/star.png" title="收藏" alt="" v-else>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!--  :data-source="tableData" -->
                    <!-- <a-table :columns="columns">
                        <a slot="name" slot-scope="text">{{ text }}</a>
                        <span slot="customTitle"><a-icon type="smile-o" /> Name</span>
                    </a-table> -->
                </div>
            </div>
        </div>
        <div class="hover-box" id="hover-box" v-show="false">
            <div class="month-hover" v-show="showHover" :style="{'top':hoverY+'px','left':hoverX+'px'}">
                <div class="btns">
                    <a href="javascript:;" class="whole-browse" @click.stop="wholeBrowse"><img src="./img/yulanc.png" alt="">整本浏览</a>
                    <a href="javascript:;" class="single-article" @click.stop="wholeBrowse"><img src="./img/yulan2c.png" alt="">篇章预览</a>
                    <!-- <router-link to="/" @click="yulan2c"><img src="./img/yulanc.png" alt="">整本浏览</router-link> -->
                    <!-- <router-link to="/bk/magazineimg"><img src="./img/yulan2c.png" alt="">预览</router-link> -->
                    <!-- <router-link to="/"><img src="./img/zhuanjic.png" alt="">专辑浏览</router-link> -->
                    <!-- <router-link to="/"><img src="./img/xiazaic.png" alt="">下载</router-link> -->
                </div>
                <a-icon type="close" style="position: absolute;top: 8px;right: 8px;color: #fff" @click="handleLeave"></a-icon>
            </div>
        </div>

        <a-modal v-model="favorVisible" width="20%" title="请选择收藏夹" @ok="createFav">
            <template slot="footer"><a-button key="cancel" type="default" @click="favorVisible=false;ifCreateFlag=false;inputFolderName=''">取消</a-button></template>
            <template slot="footer"><a-button key="submit" type="primary" @click="createFav" :disabled="ifCreateFlag">收藏</a-button></template>
            <a-radio-group v-show="!ifCreateFlag" v-model="favorFolderId">
                <a-radio v-for="(item, index) in favorFolders" :key="index" :value="item.id">
                    <span>{{item.name}}</span>
                </a-radio>
                <a-icon type="plus" v-if="!ifCreateFlag" @click="ifCreateFlag=true"/>
            </a-radio-group>
            <a-input v-if="ifCreateFlag" v-model="inputFolderName" placeholder="请输入待创建的收藏夹名称" />
            <a-icon  v-if="ifCreateFlag" type="close-circle" @click="ifCreateFlag=false;inputFolderName=''"/>
            <a-icon  v-if="ifCreateFlag" type="check-circle" @click="createFolder(inputFolderName)"/>
        </a-modal>

    </div>
</template>

<script>
    import bookNav from './../nav2'
    export default {
        components:{
            bookNav
        },
        computed:{
            dateCount(){
                if(this.choseYear===''||this.choseMonth===''){
                    return 30
                }else{
                    return new Date(this.choseYear,this.choseMonth,0).getDate()
                }
            },
            byissueParams(){
                return {
                    'year'    : this.choseYear,
                    'month'   : this.choseMonth,
                    'day'     : this.choseDate,
                    'newpaper': this.newspaperUri
                }
            },
            activeChiefEditor: function(){
                return this.newspaperData.chiefEditorUri.filter(function(item) {
                    return item.person
                })
            },
        },
        data(){
            return{
                inputFolderName: "",
                ifCreateFlag: false,
                favorVisible: false,
                bkSearchTabShow:false,
                showHover:false,
                yearsIndex: 0,  // 年下标
                monthsIndex: 0, // 月下标
                daysIndex: -1,   // 日下标
                hoverX:0,
                hoverY:0,
                choseYear:'',
                choseMonth:'',
                choseDate:'',
                baseYearList:[],
                baseYear:1920,
                yearLength:0,
                choseYearD:'',
                yearsList: null,    // 年
                monthsList: null,   // 月
                daysList: null,     // 日
                newspaperData: {},  // 报
                newspaperList: [],  // 报-表信息
                newspaperTab: false,// 默认不显示表格信息
                newspaperUri: "http://data.library.sh.cn/bk/resource/newspaper/ka0oorjhw48j0fuv",
                isCollect: [],
                collectedDataSource: [],
                favUri: "",
                favTitle: "",
                favTitlePy: '', // 题名拼音
                favorFolderId: "",
                favorFolders: [],
                columns: [
                    {
                        title: '题名',
                        dataIndex: 'title',
                        key: 'title',
                    },
                    {
                        title: '责任者',
                        dataIndex: 'co',
                        key: 'co',
                    },
                    {
                        title: '页码',
                        dataIndex: 'serialNo',
                        key: 'serialNo',
                    },
                    {
                        title: '',
                        dataIndex: 'title',
                        key: 'icon',
                    }
                ]
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.getNewspaperUri();
                this.getNewspaperIssusegroup();
                this.getNewspaperDetail();
            })
        },
        methods:{
            getNewspaperUri(){ // 获取uri
                this.newspaperUri = this.getUrlParam('uri');
                if(this.isEmpty(this.newspaperUri)){
                    this.newspaperUri = localStorage.newspaperURI;
                }
            },
            onHoverClick(){
                $(".month-hover").on("click", ".whole-browse", this.wholeBrowse);   // 整本浏览
                // $(".month-hover").on("click", ".single-article", this.wholeBrowse); // 篇章预览
                $(".month-hover").on("click", ".anticon-close", this.handleLeave);  // 弹出框关闭
            },
            onIcon(){
                $('.content').slideToggle()
            },
            prev(){
                if(this.daysIndex > 0) {
                    this.daysIndex -= 1;
                }
                else if(this.daysIndex <= 0) {
                    if(this.monthsIndex <= 0) return;
                    this.monthsIndex -= 1;
                    let _choseMonth = this.monthsList[this.monthsIndex];  // 选中月
                    this.changeMonth(_choseMonth, this.monthsIndex);
                    this.daysIndex = 0;
                }
                let _choseDate = this.daysList[this.daysIndex]; // 选中日
                this.changeDate(_choseDate, this.daysIndex);
            },
            next(){
                if(this.daysIndex < this.daysList.length-1) {
                    this.daysIndex += 1;
                } 
                else if(this.daysIndex >= this.daysList.length-1) {
                    if(this.monthsIndex >= this.monthsList.length-1) return;
                    this.monthsIndex += 1;
                    let _choseMonth = this.monthsList[this.monthsIndex];  // 选中月
                    this.changeMonth(_choseMonth, this.monthsIndex);
                    this.daysIndex = 0;
                }
                
                let _choseDate = this.daysList[this.daysIndex]; // 选中日
                this.changeDate(_choseDate, this.daysIndex);
            },
            wholeBrowse(){ // 悬浮图标整本预览
                // localStorage.CV = 0;
                // console.log(this.choseYear+"&month="+this.choseMonth+"&day="+this.choseDate);
                localStorage.newspaperManifestsKey = this.choseYear+'' + 'tixiaoyinyuan' || this.suspWeek;
                this.$router.push('/bk/newspaperimg');
                // this.$router.resolve({ path: '/bk/newspaperimg' })
                
            },
            handleLeave(e){
                this.showHover=false
                $(e.target).find('.month-hover').remove();
                // $('.wks').find('.month-hover').remove();
            },
            handleHover(e, d, index){
                this.choseDate = d;
                // this.daysIndex = index;
                // this.hoverX=e.clientX-30;
                // this.hoverY=e.clientY+20;
                setTimeout(() => {
                    // 获取弹出框 宽度 和 高度
                    let _width  = $('div.month-hover').width() + 24;
                    let _height = $('div.month-hover').height() + 24;
                    // 获取弹出框 位置 + 宽度
                    let _hoverX = e.clientX - 30 + _width;
                    // 获取弹出框 位置 + 高度
                    let _hoverY = e.clientY + 20 + _height;
                    // 获取页码可见区域 宽度和高度
                    let bodyWidth  = document.body.clientWidth;
                    let bodyHeight = document.body.clientHeight;
                    if(bodyWidth > _hoverX){ // 弹出框左边距离调节
                        // this.hoverX = e.clientX - 30;
                        this.hoverX = 0;
                    }
                    else {
                        // this.hoverX = e.clientX - _width - 20;
                        this.hoverX = -_width + $('.wks span.cur').width()+30;
                    }
                    if(bodyHeight > _hoverY){ // 弹出框上边距离调节
                        // this.hoverY = e.clientY + 20;
                        this.hoverY = $('.wks span.cur').height();
                    }
                    else {
                        // this.hoverY = e.clientY - _height - 20;
                        this.hoverY = -_height;
                    }
                    $(e.target).append($('#hover-box').html());
                    this.showHover = true;
                    // 弹出框点击事件
                    this.onHoverClick();
                }, 100);
            },
            choseYearFunc(data, index){ // 年份点击
                this.choseYear  = data.year;            // 选中当前年份
                this.monthsList = data.months;          // 月份
                this.choseMonth = data.months[0].month; // 选中第一个月份
                this.daysList   = data.months[0].days;  // 获取日
                this.yearsIndex = index;
                this.monthsIndex = 0;
                this.daysIndex = -1;
            },
            changeMonth(m, index){ // 月份点击
                this.choseMonth = m.month;  // 选中月份
                this.daysList   = m.days;   // 获取日
                this.monthsIndex = index;
                this.choseDate = '';
                this.daysIndex = -1;
            },
            changeDate(d, index){
                this.choseDate = d;
                this.daysIndex = index;
                this.getByissueNewspaper();
            },
            changeYear(y){
                this.choseYear = y

                let _index = this.baseYearList.indexOf(this.choseYear+'');
                if( _index == -1 ) return;
                let _yearobj = this.yearsList[_index];
                this.monthsList = _yearobj.months;          // 月份
                this.choseMonth = _yearobj.months[0].month; // 选中第一个月份
                this.daysList   = _yearobj.months[0].days;  // 获取日
                this.yearsIndex = _index;
                this.monthsIndex = 0;
                this.daysIndex  = -1;
            },
            changeYearD(y){
                this.monthsList = []; // 清空月份
                this.daysList = [];   // 清空日期
                if(this.choseYearD === y){
                    this.choseYearD = ''
                    this.choseYear = ''
                    return
                }
                this.choseYearD = y
                this.choseYear = y*10+this.baseYear;

                let _index = this.baseYearList.indexOf(this.choseYear+'');
                if( _index == -1 ) return;
                let _yearobj = this.yearsList[_index];
                this.monthsList = _yearobj.months;          // 月份
                this.choseMonth = _yearobj.months[0].month; // 选中第一个月份
                this.daysList   = _yearobj.months[0].days;  // 获取日
                this.yearsIndex = _index;
                this.monthsIndex = 0;
                this.daysIndex  = -1;
            },
            newspaperSearch(){
                this.$router.push({name:"literature", params:{iframeIndex: 0}});
            },
            yearUnique(y){
                if( this.isEmptyArray(y) ) return;
                this.baseYearList = [];
                let yearArr = [];
                for(let index in y){
                    let _year = y[index].year;
                    this.baseYearList.push(_year);
                    yearArr.push(_year.substring(0, 3)*10);
                }
                yearArr = this.unique(yearArr, null); // 去重
                this.baseYear = yearArr[0]-10;
                this.yearLength = yearArr.length;
                return yearArr;
            },
            getNewspaperIssusegroup(){ // 报-年月日 获取
                let params = {
                    uri: this.newspaperUri,
                };
                this.$axios.get(this.bkCommon.newspaperIssusegroupUrl, {params: params})
                .then((res) => {
                    let resultData = res.data;
                    this.yearsList = resultData.datas;
                    this.yearUnique(this.yearsList);
                    // 获取第一个年月日
                    if(this.yearsList && this.yearsList.length > 0){
                        let firstYear   = this.yearsList[0];
                        if(firstYear.year != firstYear.year.substring(0, 3)*10) return;
                        this.choseYear  = firstYear.year;   // 显示第一个年
                        this.monthsList = firstYear.months;
                        let firstMonth  = firstYear.months[0];
                        this.choseMonth = firstMonth.month; // 显示第一个月
                        this.daysList   = firstMonth.days;
                        // this.choseDate = firstMonth.days[0]; // 显示第一个日
                    }
                })
                .catch((err) => {
                    console.log(err)
                });
            },

            getNewspaperDetail(){ // 报详情

                let params = {
                    uri: this.newspaperUri,
                };
                this.$axios.get(this.bkCommon.newspaperDetailUrl, {params: params})

                .then((res) => {
                    let resultData = res.data;
                    this.newspaperData = resultData.datas;
                })
                .catch((err) => {
                    console.log(err)
                });
            },

            getByissueNewspaper(){ // 报-表信息
                this.$axios.get(this.bkCommon.byissueNewspaperUrl, {params: this.byissueParams})
                .then((res) => {
                    let resultData = res.data;
                    this.newspaperList = resultData.datas;
                    this.newspaperTab = true;
                    // this.setStarCollect();
                    // 查询用户收藏列表
                    if(this.Common.userInfo) {
                        this.searchCollectCode()
                    }
                })
                .catch((err) => {
                    console.log(err)
                });
            },

            // 查询用户收藏列表
            searchCollectCode() {
                this.collectedDataSource = []
                let resourceCodes = []
                this.newspaperList.forEach(element => {
                    resourceCodes.push(element["@id"])
                });
                this.$axios.post(this.Common.searchCollectCode, {
                    appId: "history",
                    userId: this.Common.userInfo.id,
                    version: "1.0",
                    token: this.getTokenFunc(),
                    body: {
                    resourceCodes: resourceCodes
                    }
                })
                .then((res) => {
                    if(res.data.resultCode === "0000") {
                        if(res.data.body&&res.data.body.length>0) {
                            res.data.body.forEach(element => {
                                this.collectedDataSource.push(element.resourceCode)
                            });
                        }
                    } else {
                    this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    console.log(err)
                });
            },

            async handleFav(uri, title, titlePy){
                this.favUri = uri
                this.favTitle = title
                this.favTitlePy = titlePy // 题名拼音
                let index = this.collectedDataSource.indexOf(this.favUri)
                if(index>-1) { // 取消收藏
                    this.collectedDataSource.splice(index,1)
                    this.collectHandle(this.favUri, this.favTitle)
                } else {  // 添加收藏 
                    this.favorFolders = []
                    this.favorFolderId = ""
                    await this.$axios.post(this.Common.searchFavorites, {
                        appId: "history",
                        userId: this.Common.userInfo.id,
                        version: "1.0",
                        token: this.token||this.getTokenFunc(),
                        body: {}
                    }).then(response => {
                        let list = response.data.body
                        if(list && list.length>0 && list.map(element=>element.favoritesType).indexOf('D')>-1) {
                            list.forEach(element => {
                                if(element.favoritesType=='D') {
                                    this.favorFolders.push(element)
                                }
                            });
                            this.favorFolderId = this.favorFolders[0].id
                            this.favorVisible = true
                            this.ifCreateFlag = false
                            this.inputFolderName = ""
                        } else {
                            this.createFolder("默认")
                        }
                    });
                }
            },

            createFav() {
                this.collectedDataSource.push(this.favUri)
                this.createCollect(this.favUri, this.favTitle, "https://dhc.library.sh.cn/bk/newspaperimg?articleUri=", this.choseYear, this.suspWeek || this.favTitlePy, this.favorFolderId) // 添加收藏
                this.favorVisible = false
            },

            async createFolder(name) {
                if(!name.trim()) {
                    this.$message.error("收藏夹名称不能为空");
                } else {
                    await this.$axios.post(this.Common.createFavorites, {
                        appId: "history",
                        userId: this.Common.userInfo.id,
                        version: "1.0",
                        token: this.token||this.getTokenFunc(),
                        body: {
                            name: name,
                            parent: 0,
                            favoritesType: "D"
                        }
                    }).then(response => {
                        if(response.data.resultCode=="0000") {
                            this.handleFav(this.favUri, this.favTitle, this.favTitlePy)
                        } else {
                            this.$message.error("System Error");
                        }
                    });
                }
            },

            bkSearchShow(visible){ // 高级检索弹框显示
                this.bkSearchTabShow = visible;
                // this.handleLeave(); // 关闭弹出框
                this.unScroll(); // 禁止滚动条滚动
            },
            bkSearchHide(visible){ // 高级检索弹框隐藏
                this.bkSearchTabShow = visible;
                this.removeUnScroll(); // 移除禁止滚动条滚动
            },
            // setStarCollect(){ // 收藏图标判断
            //     this.isCollect = [];
            //     for (let i=0, len=this.newspaperList.length; i<len; i++) {
            //         this.isCollect.push({star:false});
            //     }
            // },
            
            // starCollect(index){ // 收藏
            //     this.isCollect[index].star = !this.isCollect[index].star;
            // },

            fullBrowse(item){ // 整本浏览
                localStorage.newspaperManifestsKey = this.choseYear+'' + item.titlePy || this.suspWeek;
                this.$router.push('/bk/newspaperimg');
                // this.$router.resolve({ path: '/bk/newspaperimg' })
            },
            dpBrowse(item){ // 单篇预览
                localStorage.newspaperManifestsKey = this.choseYear+'' + item.titlePy || this.suspWeek;
                this.$router.push('/bk/newspaperimg');
                // this.$router.resolve({ path: '/bk/newspaperimg' })
            },
            zjBrowse(item){ // 专辑浏览
                localStorage.newspaperManifestsKey = this.choseYear+'' + item.titlePy || this.suspWeek;
                this.$router.push('/bk/newspaperimg');
                // this.$router.resolve({ path: '/bk/newspaperimg' })
            },
            onExport(){ // 信息导出
                let _this = this;
                if( !_this.Common.userInfo ){
                    _this.$Modal.info({ content : '请登录!', okText  : '确定', });
                    return;
                }
                _this.onResultExport();
            },
            onResultExport(){ // 导出内容设置
                let _this      = this;
                let title      = [];     // csv文档标题
                let exportData = [];     // csv文档数据
                let fileName   = 'temp'; // 文件名
                let titleArr   = [
                    {ch:'报名',     en:"titleChs"}, 
                    {ch:'责任者',   en:"chiefEditor"}, 
                    {ch:'创报时间', en:"created"}, 
                    {ch:'出版者',   en:"publisher"}, 
                    {ch:'出版地',   en:"address"},
                    {ch:'语种',     en:"language"}, 
                    {ch:'资源uri',  en:"uri"}
                ]; // 文档标题集合
                titleArr.forEach((item) => {
                    title.push({title: item.ch  , field: item.en});  // 设置标题
                })
                exportData = _this.onCsvExportData();
                _this.JSONToExcelConvertor(title, exportData, fileName); // 导出csv文件
            },
            onCsvExportData(){ // csv导出数据处理
                let exportData = [{
                    titleChs    : this.newspaperData.titleChs,
                    chiefEditor : this.listUniqToString(this.newspaperData.chiefEditor, "chiefEditor", '、'),
                    created     : this.newspaperData.created,
                    publisher   : this.listUniqToString(this.newspaperData.publisher, "name", '、'),
                    address     : this.newspaperData.address,
                    language    : this.listUniqToString(this.newspaperData.language, "languagelabel", '、'),
                    uri         : this.newspaperData['@id'],
                }]
                return exportData;
            }
        }
    }
</script>

<style lang="less" scoped>
    /deep/ .ant-modal-content, /deep/ .ant-modal-header {
        background: #E8F1F9;
    }
    /deep/ .ant-modal {
        top: 35%;
        padding-bottom: 0;
    }
    /deep/ .anticon-plus {
        position: relative;
        display: inline-block;
        cursor: pointer;
    }
    /deep/ .anticon-close-circle, /deep/ .anticon-check-circle {
        margin-left: 6%;
    }
    /deep/ .ant-input {
        width: 70%;
    }

    .newspaper-detail{
        background: #e3e3e3;
        width: 100%;
        min-height: calc(100vh);
    }

    /deep/.ant-table-content{
        color: #334b87;
        .ant-table-thead {
            tr {
                &:first-child{
                    th:first-child,
                    th:nth-child(3){
                        letter-spacing: 20px;
                    }
                }
                th{
                    padding: 16px 0;
                    background: transparent;
                    color: #334b87;
                }
            }
        }
        .ant-table-tbody{
            tr{
                td{
                    padding: 16px 0;
                    color: rgba(0, 0, 0, 0.65);
                }
            }
        }
    }

    /deep/ .result-page-nav{ 
        .nav-search{ 
            .ipt{
                background: #fff;
            }
        }
    }
    /deep/ .result-page-nav {
        .nav-search{ 
            .ipt {
                .icon{
                    background-image: url("./img/searchicon2.png");
                }
            }
        }
    }
    .month-hover{
        // position: fixed;
        position: absolute;
        width: 200px;
        background: #334b87;
        padding: 12px;
        border-radius: 10px;
        // top: 400px;
        left: 0;
        z-index: 999;
        .btns{
            display: flex;
            flex-wrap: wrap;
            a{
                display: flex;
                align-items: center;
                color: #fff;
                line-height: 34px;
                font-size: 12px;
                border-bottom: none;
                width: 50%;
                img{
                    width: 20px;
                    height: 20px;
                    margin-right: 6px;
                }
                &:hover{
                    color: #f0be73;
                }
            }
        }
    }
    .newspaper-box{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 0 2%;
        &.cur{
            opacity: 0.2;
        }
        .left-info{
            width: 30%;
            min-width: 300px;
            max-width: 440px;
            margin-right: 20px;
            background: #e8f1f9;
            border-radius: 10px;
            padding: 30px;
            flex-shrink: 0;
            img{
                display: block;
                margin: 0 auto;
                // width: 50%;
                width: 80%;
                height: auto;
            }
            .des{
                margin-top: 15px;
                p{
                    margin: 0 0 5px 0;
                    font-size: 14px;
                    display: flex;
                    span:not(.person-t){
                        color: #334b87;
                        width: 80px;
                        flex-shrink: 0;
                    }
                }
            }
            .btns{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 15px;
                a{
                    width: 120px;
                    font-size: 14px;
                    height: 34px;
                    border-radius: 17px;
                    background: #334b87;
                    color: #fff;
                    text-align: center;
                    line-height: 34px;
                    margin: 0 10px;
                }
            }
        }
        .right-content{
            flex-grow: 1;
            .newspaper-des{
                // margin-top: 20px;
                background: #e8f1f9;
                border-radius: 10px;
                padding: 10px 50px;
                position: relative;
                margin-bottom: 20px;
                i.icon{
                    position: absolute;
                    width: 24px;
                    height: 43px;
                    background-size: 100% 100%;
                    background-image: url("./../magazineDetail/tag.png");
                    top: -10px;
                    left: 15px;
                    cursor: pointer;
                }
                .content{
                    font-size: 14px;
                    overflow-y: auto;
                    max-height: 66px;
                    p{
                        text-indent: 2em;
                        line-height: 1.5;
                        margin-bottom: 10px;
                    }

                    // 滚动条样式
                    &::-webkit-scrollbar {
                        width: 6px;
                        height: 6px;
                    }
                    &::-webkit-scrollbar-thumb {
                        border-radius: 10px;
                        -webkit-box-shadow: inset 0 0 5px rgba(51,75,135, 0.6);
                        box-shadow: inset 0 0 5px rgba(51,75,135, 0.6);
                        background: rgba(51,75,135, 0.6);
                    }
                    &::-webkit-scrollbar-track {
                        -webkit-box-shadow: inset 0 0 5px rgba(51,75,135, 0.4);
                        box-shadow: inset 0 0 5px rgba(51,75,135, 0.4);
                        border-radius: 5px;
                        background: rgba(51,75,135, 0.2);
                    }
                }
                h5{
                    color: #334b87;
                    font-size: 16px;
                    line-height: 1.5;
                    margin-bottom: 15px;
                }
            }
            .top-filter{
                background: #e8f1f9;
                // border-radius: 10px;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                padding: 30px;
                .filter{
                    display: flex;
                    line-height: 1.5;
                    margin-bottom: 15px;
                    .lb{
                        width: 80px;
                        flex-shrink: 0;
                        color: #334b87;
                        letter-spacing: 20px;
                    }
                    .wks{
                        display: flex;
                        flex-wrap: wrap;
                        position: relative;
                        span{
                            background: #fff;
                            border-radius: 11px;
                            padding: 0 15px;
                            height: 22px;
                            margin-right: 10px;
                            margin-bottom: 10px;
                            display: inline-block;
                            font-size: 13px;
                            line-height: 22px;
                            position: relative;
                            cursor: pointer;
                            &.cur{
                                background: #f0be73;
                            }
                        }
                    }
                    .years{
                        display: flex;
                        flex-wrap: wrap;
                        .an{
                            display: flex;
                            max-width: 0;
                            overflow: hidden;
                            transition: max-width .6s;
                            &.cur{
                                transition: max-width .6s;
                                max-width: 700px;
                            }
                        }
                        span{
                            font-size: 12px;
                            position: relative;
                            width: 80px;
                            height: 40px;
                            padding: 22px 0 0 0;
                            line-height: 18px;
                            box-sizing: border-box;
                            cursor: pointer;
                            margin-bottom: 10px;
                            &.y2{
                                width: 50px !important;
                                &:after{
                                    display: none;
                                }
                                &:before{
                                    width: 100%;
                                    left: 0;
                                    height: 4px;
                                    border-radius: 0;
                                    background: #ccc;
                                    border: none;
                                    border-bottom: 1px solid #f0be73;
                                }
                                &:nth-of-type(2n){
                                    &:before{
                                        background: #fff;
                                    }
                                }
                                &.cur{
                                    color: #334b87;
                                    font-weight: bold;
                                }
                            }
                            &.cur{
                                text-decoration: underline;
                                color: #334b87;
                                font-weight: bold;
                            }
                            // &.cur{
                            //     width: 60px;
                            //     i{
                            //         &.cur{
                            //             color: #334b87;
                            //             font-weight: bold;
                            //         }
                            //     }
                            //     &:after{
                            //         width: 50px;
                            //         height: 4px;
                            //         border-radius: 0;
                            //         background: #fff;
                            //         border: none;
                            //         top: 0;
                            //         border-bottom: 1px solid #f0be73;
                            //     }
                            //     &:first-child{
                            //         &:after{
                            //             width: 50px;
                            //         }
                            //     }
                            // }
                            &:first-child{
                                &:after{
                                    width: 70px;
                                }
                            }
                            &:last-child{
                                &:after{
                                    width: 10px;
                                    right: 70px;
                                }
                            }
                            &:before{
                                position: absolute;
                                width: 10px;
                                height: 10px;
                                border-radius: 5px;
                                top: 0;
                                left: 0;
                                background: #f0be73;
                                content: '';
                                z-index: 2;
                            }
                            &:after{
                                position: absolute;
                                width: 80px;
                                height: 1px;
                                top: 4px;
                                right: 0;
                                background: #f0be73;
                                content: '';
                            }
                        }
                    }
                }
            }
            .pager{
                text-align: center;
                color: #334b87;
                -moz-user-select: none;
                -khtml-user-select: none;
                user-select: none;
                // background: rgb(232,241,249;0.6);
                background: #fff;
                line-height: 50px;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                font-size: 16px;
                span{
                    color: #334b87;
                    margin: 0 20px;
                    &.cur{
                        cursor: pointer;
                        margin: 0 5px;
                    }
                }
            }
            .result-tab{
                background: #e8f1f9;
                border-radius: 10px;
                padding: 30px;
                text-align: center;
                margin: 20px auto;
                table{
                    margin: 0 auto;
                    width: 100%;
                    tr{
                        line-height: 2.4;
                        text-align: left;
                        th{
                            width: 1%;
                            color: #334b87;
                            font-weight: normal;
                            flex-shrink: 0;
                            letter-spacing: 20px;
                            &.cur{
                                letter-spacing: normal;
                            }
                        }
                        td{
                            line-height: 24px;
                        }
                    }
                    &.tabs{
                        .icon-img{
                            a{
                                margin: 0 5px;
                                .star{
                                    width: 27px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
